//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
    state: {
        fsiDriverMaster: [],
        searchRequest: null,
      },

      mutations: {
        updateFSIDriverMaster(state, list) {
          state.fsiDriverMaster = list;
        },
        updateSearchFSIDriverMasterRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async fsiDriverMaster({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))
          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/fsi/searchDriverData', requestToSend);
          const result = await newAPIPost('/api/w/fsi/searchDriverData', requestToSend);
          //const result = await api.post('/api/w/gstMasterData/driverMasterData', drivers = null, transYard = null, defaultSalesOffice = "LGB");
          commit('updateSearchFSIDriverMasterRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updateFSIDriverMaster', result);
                },
      },

      getters: {
        getFSIDriverMaster: state => state.fsiDriverMaster,
      },
}